// extracted by mini-css-extract-plugin
export default {"content":"usd-rewards-rule_content__jYFmo","text":"usd-rewards-rule_text__ywW2k","title":"usd-rewards-rule_title__GJdBn"};